import script from "./PaypalBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaypalBtn.vue?vue&type=script&lang=ts&setup=true"

import "./PaypalBtn.vue?vue&type=style&index=0&id=96105322&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96105322"]])

export default __exports__